import {
  leadsTasksListQueryKey,
  opportunitiesTasksListQueryKey,
  ReturnTaskReadable,
  tasksDestroyMutation,
  tasksRetrieveQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

type Props = {
  task: ReturnTaskReadable | null
  onCancel: () => void
}

export const DeleteTask = ({ task, onCancel, ...props }: Props) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { mutate, isPending } = useMutation({
    ...tasksDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsTasksListQueryKey({
          path: {
            lead_id: String(task?.lead?.id)
          }
        }),
        tasksRetrieveQueryKey({
          path: {
            id: Number(task?.id)
          }
        }),
        opportunitiesTasksListQueryKey({
          path: {
            opportunity_id: String(task?.opportunity?.id)
          }
        })
      ])
      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!task?.id) return

    mutate({ path: { id: task?.id } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
